module.exports = __webpack_public_path__ + "3a0d4a58da62cf7c55bb243e98b172b5.ttf";